import { render, staticRenderFns } from "./OrmSubmitTaxInvoiceModal.vue?vue&type=template&id=2d0be585&scoped=true"
import script from "./OrmSubmitTaxInvoiceModal.vue?vue&type=script&lang=js"
export * from "./OrmSubmitTaxInvoiceModal.vue?vue&type=script&lang=js"
import style0 from "./OrmSubmitTaxInvoiceModal.vue?vue&type=style&index=0&id=2d0be585&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0be585",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d0be585')) {
      api.createRecord('2d0be585', component.options)
    } else {
      api.reload('2d0be585', component.options)
    }
    module.hot.accept("./OrmSubmitTaxInvoiceModal.vue?vue&type=template&id=2d0be585&scoped=true", function () {
      api.rerender('2d0be585', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/OrmSubmitTaxInvoiceModal.vue"
export default component.exports